export const BY_ENTITY_ID = 'by Entity Id';

export const KYC_STATUS_OPTIONS = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'failed',
    label: 'Failed',
  },
];

export const SUMSUB_KYC_STATUS = {
  PASS: 'PASS',
  FAILED: 'FAIL',
};

export const KYB_STATUS_OPTIONS = [
  {
    value: 'succeeded',
    label: 'Succeeded',
  },
  {
    value: 'failed',
    label: 'Failed',
  },
];

export const KYB_KYC_SUCCESS_STATUS = ['succeeded', 'active'];

export const RISK_LEVEL_COLOR_CODES = {
  'Low risk': 'green.500',
  'Medium risk': 'yellow.500',
  'High risk': 'red.500',
};

export const RFI_TAGS_TYPE = [
  {
    value: 'high_risk_edd',
    label: 'High risk EDD',
  },
  {
    value: 'identity_card',
    label: 'Identity Card',
  },
  {
    value: 'kyc_form',
    label: 'KYC form',
  },
  {
    value: 'txn_edd',
    label: 'Txn EDD',
  },
  {
    value: 'sanctions',
    label: 'Sanctions',
  },
  {
    value: 'adverse_media',
    label: 'Adverse media',
  },
  {
    value: 'others',
    label: 'Others',
  },
];

export const KYC_FORM_SUB_TYPE = [
  {
    value: 'dob_mismatch',
    label: 'DOB mismatch',
  },
  {
    value: 'employer_details',
    label: 'Employer details',
  },
  {
    value: 'name_mismatch',
    label: 'Name mismatch',
  },
  {
    value: 'questionnaire',
    label: 'Questionnaire',
  },
  {
    value: 'selfie',
    label: 'Selfie',
  },
  {
    value: 'sof_incorrect',
    label: 'SOF incorrect',
  },
];

export const RFI_SUB_TYPE = { kyc_form: KYC_FORM_SUB_TYPE };
